import React from 'react';
import { CalendarIcon, ClockIcon, VideoIcon, UsersIcon } from 'lucide-react';
const UpcomingEventsWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-1063">
      <div className="p-4 flex justify-between items-center" data-id="element-1064">
        <h2 className="text-base font-semibold text-gray-800" data-id="element-1065">
          Eventi Imminenti
        </h2>
        <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-1066">
          Visualizza Calendario
        </button>
      </div>
      <div className="p-4" data-id="element-1067">
        <div className="space-y-4" data-id="element-1068">
          <EventItem title="Workshop Innovazione Sostenibile" date="Oggi" time="14:00 - 15:30" type="webinar" data-id="element-1069" />
          <EventItem title="Discussione Tecnologie Green" date="Domani" time="11:00 - 12:00" type="meeting" data-id="element-1070" />
          <EventItem title="Casi Studio Economia Circolare" date="25 Maggio" time="14:00 - 16:00" type="webinar" data-id="element-1071" />
        </div>
      </div>
    </div>;
};
interface EventItemProps {
  title: string;
  date: string;
  time: string;
  type: 'webinar' | 'meeting' | 'deadline';
}
const EventItem: React.FC<EventItemProps> = ({
  title,
  date,
  time,
  type
}) => {
  const getEventIcon = () => {
    switch (type) {
      case 'webinar':
        return <VideoIcon size={16} className="text-gray-500" data-id="element-1072" />;
      case 'meeting':
        return <UsersIcon size={16} className="text-gray-500" data-id="element-1073" />;
      case 'deadline':
        return <ClockIcon size={16} className="text-gray-500" data-id="element-1074" />;
      default:
        return null;
    }
  };
  const getTypeLabel = () => {
    switch (type) {
      case 'webinar':
        return 'Webinar';
      case 'meeting':
        return 'Incontro';
      case 'deadline':
        return 'Scadenza';
      default:
        return '';
    }
  };
  return <div className="flex" data-id="element-1075">
      <div className="mr-3 mt-1" data-id="element-1076">
        <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center" data-id="element-1077">
          <CalendarIcon size={18} className="text-gray-600" data-id="element-1078" />
        </div>
      </div>
      <div data-id="element-1079">
        <h3 className="font-medium text-gray-800" data-id="element-1080">{title}</h3>
        <div className="text-sm text-gray-500 mb-1" data-id="element-1081">
          {date} • {time}
        </div>
        <div className="flex items-center text-xs" data-id="element-1082">
          <span className="mr-1" data-id="element-1083">{getEventIcon()}</span>
          <span className="text-gray-600" data-id="element-1084">{getTypeLabel()}</span>
          {date === 'Oggi' && <>
              <span className="mx-2 text-gray-400" data-id="element-1085">•</span>
              <span className="text-custom-green font-medium" data-id="element-1086">
                Inizia tra 3 ore
              </span>
            </>}
        </div>
      </div>
    </div>;
};
export default UpcomingEventsWidget;